export const shadows = {
  card: '0px 4px 16px rgba(0, 0, 0, 0.1), 0px 0px 4px -1px rgba(0, 0, 0, 0.3)',
  popover: '0px 4px 16px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.25)',
  'inner-blue': 'inset 4px 0 0 0 rgba(0, 126, 161, 1)',
};
